<template>
  <div class="n-icon-wrap">
    <div class="icon" :style="{ width: nSize, height: nSize, background: nColor }">
      <span class="iconfont" :class="fullIconName" :style="{ lineHeight: nSize, fontSize }"></span>
    </div>
    <div class="title" :style="{ color: nColor, fontSize: textFontSize }">{{ title }}</div>
  </div>
</template>

<script>
import { getColor } from '@/utils/deviceUtils/state';

export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: 'icon-'
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 100
    },
    color: {
      type: String,
      default: ''
    },
    state: {
      type: [Number, String],
      default: '0'
    },
    runstate: {
      type: [Number, String],
      default: '0'
    }
  },
  computed: {
    fullIconName() {
      return this.prefix + this.icon;
    },
    nSize() {
      return this.size + 'px';
    },
    fontSize() {
      return this.size * 0.6 + 'px';
    },
    textFontSize() {
      return this.size / 4.5 + 'px';
    },
    nColor() {
      const c = getColor(this.runstate, this.state);
      return this.color || (c === 'unset' ? '#03b36e' : c);
      //   return this.color || getColor(this.runstate, this.state);
    }
  }
};
</script>

<style lang="scss">
.n-icon-wrap {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  .icon {
    display: inline-block;
    border-radius: 50%;
    color: #000;
  }
  .title {
    margin-top: 10px;
    text-align: justify;
    padding: 0 5px;
    &::after {
      display: inline-block;
      width: 100%;
      content: '';
    }
  }
}
</style>
